import { Component, OnInit, OnDestroy, AfterViewInit, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { DomSanitizer } from '@angular/platform-browser';
import { UserService } from '../../services/user.service';
import { PIDService } from '../../services/pid.service';
import { FileService } from '../../services/file.service';
import { NotificationService } from '../../services/notification.service';
import { SearchbarService } from '../../services/searchbar.service';
import { TranslateService } from '@ngx-translate/core';
import { MatDialog } from '@angular/material/dialog';
import { MassEditDialog } from "../massedit/massedit.component";
import { ProfileService } from '../../services/profile.service';

import * as _ from 'lodash';
import { ContractorService } from '../../services/contractor.service';
import { TemplateService } from '../../services/template.service';

import { Subject } from 'rxjs';


@Component({
  selector: 'pid',
  templateUrl: './pid.component.html',
  styleUrls: ['./pid.component.scss']
})
export class PIDComponent implements OnInit, OnDestroy, AfterViewInit {
  pid = null;
  fileViewUrls = [];
  viewFile = null;

  files = {
    all: [],
    display: [],
    selectedRow: null
  };

  rawfiles = [];

  fileToDelete = null;
  fileToEdit = null;
  fileToUpdate = null;
  contractorFileToUpdate = null;
  filesToUpload = [];
  selection = false;

  pending = {
    all: [],
    display: [],
    selectedRow: null,
  };

  modal = {
    newFile: false,
    viewFile: false,
    newPID: false,
    deleteFile: false
  };

  steps = [];
  postURL = '';
  private _sub;

  tabindex = -1;
  isPhone = null;

  profile = null;



  @ViewChild('tabGroup') _tabGroup;
  @ViewChild('modalNewPID') modalNewPID;
  @ViewChild('modalUpdateFile') modalUpdateFile;
  @ViewChild('modalNewFile') modalNewFile;
  @ViewChild('fileTable') fileTable;
  @ViewChild('subpidTable') subpidTable;


  private eventsSubject: Subject<void> = new Subject<void>();

  emitEventToChild() {
    this.eventsSubject.next()
  }

  constructor(private _router: Router, private _route: ActivatedRoute, private _user: UserService,
    private _pid: PIDService, private _notification: NotificationService, private _fileService: FileService,
    private _sanitizer: DomSanitizer, public translate: TranslateService, private _templateService: TemplateService,
    private _profile: ProfileService,
    private _searchService: SearchbarService, private _contractorService: ContractorService, public dialog: MatDialog) {
    this.steps.push({ name: ['Proprieties'], ref: [''] });
  }

  private _addStep() {
    this.steps = [{ name: ['Proprieties'], ref: [''] }];
    if (this.pid.parentPID) {
      console.log("parent pid", this.pid.parentPID);
      this.steps.push({
        name: ['DATA.PID', ': ', this.pid.parentPID.name],
        ref: ['pid', this.pid.parentPID._id]
      });
    }
    this.steps.push({
      name: ['DATA.PID', ': ', this.pid.name],
      ref: ['pid', this.pid._id]
    });
  }


  updateTabIndex(tabindex) {
    console.log("update tab index");
    this.tabindex = tabindex;
    this.selection = false;

    this._router.navigate(['.'], {
      relativeTo: this._route,
      queryParams: { tabindex: tabindex },
      queryParamsHandling: 'merge'
    })
  }

  lock(id) {
    this._fileService.lock(id).subscribe((f: any) => {
      const found = _.find(this.files.all, (e: any) => {
        return e._id == f._id;
      });
      if (found) {
        _.merge(found, f);
      }
    });
  }


  goToTemplate() {
    this._router.navigate(['template', this.pid._id]);
  }

  formatFileForTemplate(f) {
    let template = {};

    template['type'] = f.type;
    template['name'] = f.name;
    template['description'] = f.description;
    template['room'] = f.room;
    template['profile'] = this.profile._id;

    if (f.contractor) {
      template['contractor'] = f.contractor._id;
    }
    if (this.profile.company) {
      template['company'] = this.profile.company;
    }

    return template;
  }

  addToTemplates() {
    let selection = this.fileTable.currentSelection();
    var filesPerId = this.rawfiles.reduce(function (map, obj) {
      map[obj['_id']] = obj;
      return map;
    }, {});

    console.log("add to templates", selection);
    var templates = [];

    selection.forEach(x => {
      templates.push(this.formatFileForTemplate(filesPerId[x]));
    });
    this._templateService.updateTemplates(this.profile._id, templates).subscribe(stats => {
      console.log("res", stats);
      this.selectNone();
      if (stats['updated'] || stats['created']) {
        this._notification.info('TEMPLATE.COPIED');
      }
    });
  }

  goTo() {
    this._router.navigate(['pid', this.pid._id]);
  }

  unlock(id) {
    this._fileService.unlock(id).subscribe((f: any) => {
      const found = _.find(this.files.all, (e: any) => {
        return e._id == f._id;
      });
      if (found) {
        _.merge(found, f);
      }
    });
  }

  hasLate(collection) {
    const today = new Date();
    return _.find(collection.all, (f: any) => {
      if (!f['deadline']) {
        return false;
      }
      return new Date(f['deadline']) < today;
    });
  }

  hasIncomplete(collection) {
    return _.find(collection.all, (f: any) => {
      return !f['emailSent'];
    });
  }

  isLate(f) {
    const today = new Date();
    if (!f['deadline']) {
      return false;
    }
    return new Date(f.deadline) < today;
  }


  filterOnOff() {
    this.fileTable.showfilters = this.fileTable.showfilters ? false : true;
  }

  ngOnInit() {
    console.log("ng on init");

    this.isPhone = window.matchMedia('(max-width: 767px)').matches;
  }

  ngOnDestroy() {
    this._sub.unsubscribe();
  }

  private _init() {
    this.pending = { all: [], display: [], selectedRow: null };
    this.files = { all: [], display: [], selectedRow: null };
    this.fileViewUrls = [];
    this.viewFile = null;
    this.fileToDelete = null;
    this.fileToEdit = null;
    this.fileToUpdate = null;
    this.contractorFileToUpdate = null;
    this.filesToUpload = [];
    this.modal = { newFile: false, viewFile: false, newPID: false, deleteFile: false };
    this.steps = [];
    this.postURL = '';
  }

  ngAfterViewInit() {
    this._profile.me(true).subscribe(profile => this.profile = profile);

    this._sub = this._route.params.subscribe(params => {
      this._init();
      console.log("ngAfterViewInit pid pre get", params['id']);
      var setTabIndex = -1;
      this._route.queryParams.subscribe(params => {
        console.log("pid components params", params);
        if (params.hasOwnProperty('tabindex')) {
          setTabIndex = params.tabindex;
        }
      });

      this._pid.get(params['id'])
        .subscribe(
          (pid: any) => {
            this.pid = pid;
            this.reloadFiles();
            this.pid.children = { display: pid.children, all: pid.children, filtered: pid.children };

            this._addStep();
            this.tabindex = setTabIndex != -1 ? setTabIndex : pid && !pid.parentPID && pid.children.display.length > 0 ? 1 : 0;
            console.log("setting tabindex to", this.tabindex);
          },
          err => this._notification.errorServer(err)
        );

    });
  }

  getFileURL(f) {
    this._fileService.getFileURL(this.pid._id, f)
      .subscribe(
        (ret: any) => {
          f.version = ret.version;
          this.fileViewUrls = _.map(f.version.files, (file, i) => {
            return {
              type: file['fileType'],
              name: file['name'],
              originalGetUrl: ret.urls[i],
              getUrl: this._sanitizer.bypassSecurityTrustResourceUrl(ret.urls[i]),
              downloadUrl: this._sanitizer.bypassSecurityTrustUrl(ret.urls[i])
            };
          });

          this.viewFile = f;
        },
        err => {
          this._notification.errorServer(err);
        }
      );
  }

  getOriginalFile(f) {
    this._fileService.getOriginalFileVersion(this.pid._id, f)
      .subscribe(
        (ret: any) => {
          _.forEach(ret.version.files, (file, i) => {
            const a = document.createElement('a');
            a.href = ret.urls[i];
            a.target = '_self';
            a.download = file.name;
            a.click();
          });
        },
        this._notification.errorServer
      );
  }

  selectAll() {
    this.selection = true;
    this.fileTable.selectAll();
  }

  selectNone() {
    this.selection = false;
    this.fileTable.selectNone();
  }

  filterFct = (filter) => {
    switch (this._tabGroup.selectedIndex) {
      case 0:
        this._searchService.filter(this.pending, filter, ['version', 'PID']);
        this._searchService.filter(this.files, filter, ['version', 'PID']);
        this.fileTable.updateData();
        break;
      case 1:
        this._searchService.filter(this.files, filter, ['version', 'PID']);
        break;
      case 2:
        this._searchService.filter(this.pending, filter, ['version', 'PID']);
        break;
      case 3:
        this._searchService.filter(this.pid.children, filter, ['PIDOwner', 'img', '_id', 'transferTo']);
        break;
      default:
        break;
    }

    this.eventsSubject.next();
  }

  isMine() {
    return (this.pid && this.pid.PIDOwner['_id'] == this._user.me()['_id']);
  }


  isMineOrShared() {
    if (!this.pid) return false;
    return (this.pid && ((this.pid.PIDOwner['_id'] == this._user.me()['_id']) ||
      (this.pid.sharedWith && this.pid.sharedWith.filter(x => x == this._user.me()['_id']).length) ||
      (this.pid.parentPID && this.pid.parentPID.sharedWith.filter(x => x == this._user.me()['_id']).length) ||
      (this.pid.PIDOwner.company == this._user.me()['company'])
    ));
  }

  canAddPID() {
    /*if (this.profile)
      console.log("can add", this.profile.nbPIDTotal, this.profile.PIDLimit);*/
    return (this.profile && this.profile.nbPIDTotal < this.profile.PIDLimit);
  }

  isCopy() {
    return (this.pid && this.pid.copy);
  }

  isEditable(file) {
    return !this.isCopy() && this.pid && file && file.PID && (file.PID._id || file.PID) === this.pid._id;
  }

  stringify(data) {
    return JSON.stringify(data);
  }

  goToChildren(c) {
    this._router.navigate(['pid', c._id]);
  }

  goToFileDetails(id) {
    this._router.navigate(['file', id, this.pid._id]);
  }

  private _computePercentage() {
    const total = this.files.all.length + this.pending.all.length;
    const completed = this.files.all.length;
    this.pid.percentage = Math.ceil(total ? (completed / total * 100) : 0);

    this.pid.fileCompleted = completed;
    this.pid.fileTotal = total;
  }

  newFileCompleted = (f) => {
    this.modal.newFile = false;
    this.fileToUpdate = null;
    if (f.version) {
      const found = _.find(this.files.all, e => {
        return e._id == f._id;
      });
      if (!found) {
        this.files.all.push(f);
        this.files.display.push(f);
      } else {
        _.merge(found, f);
      }
      //this._tabGroup.selectedIndex = 0;
    } else {
      const found = _.find(this.pending.all, e => {
        return e._id == f._id;
      });
      if (!found) {
        this.pending.all.push(f);
        this.pending.display.push(f);
      } else {
        _.merge(found, f);
      }
      //this._tabGroup.selectedIndex = 1;
    }
    this._computePercentage();
    this._pid.get(this.pid['_id'])
      .subscribe(
        (pid: any) => {
          this.pid = pid;
          this.pid.children = { display: pid.children, all: pid.children };
        }
      );

    this.updateFileTable();
  }

  updateFileTable = () => {
    this.fileTable.pending = this.pending;
    this.fileTable.files = this.files;
    this.fileTable.updateData();
    this._tabGroup.selectedIndex = 0;
  }

  deleteFile(f) {
    this.fileToDelete = f;
    this.modal.deleteFile = true;
  }

  confirmDeleteFile() {
    this._fileService.deleteFile(this.pid._id, this.fileToDelete._id)
      .subscribe(
        () => {
          _.remove(this.files.display, f => {
            return (f._id == this.fileToDelete._id);
          });
          _.remove(this.files.all, f => {
            return (f._id == this.fileToDelete._id);
          });
          _.remove(this.pending.display, f => {
            return (f._id == this.fileToDelete._id);
          });
          _.remove(this.pending.all, f => {
            return (f._id == this.fileToDelete._id);
          });
          this.modal.deleteFile = false;
          this._computePercentage();

          this.updateFileTable();
        },
        this._notification.errorServer
      );
  }

  fileChangeEvent(fileInput) {
    this.filesToUpload = fileInput.target.files;
  }

  uploadFile() {
    const _self = this;
    let done = 0;
    this._fileService.editFile(this.fileToEdit, this.filesToUpload)
      .subscribe(urls => {
        const files = _.map(this.filesToUpload, (file, i) => {
          return ({ file: file, url: urls[i] });
        });
        _.forEach(files, (file) => {
          _self._fileService.uploadTo(file.url, file.file, _self.fileToEdit._id)
            .finally(() => {
              ++done;
              if (done == files.length) {
                _self._fileService.convertToPDF(_self.fileToEdit._id).subscribe();
                _.remove(_self.pending.display, f => {
                  return (f._id == _self.fileToEdit._id);
                });
                _.remove(_self.pending.all, f => {
                  return (f._id == _self.fileToEdit._id);
                });
                _self.fileToEdit['version'] = { date: new Date() };
                _self.files.display.push(_self.fileToEdit);
                _self.files.all.push(_self.fileToEdit);
                _self.filesToUpload = [];
                _self.fileToEdit = null;
                _self._tabGroup.selectedIndex = 0;
                _self._computePercentage();
                _self.updateFileTable();
              }
            })
            .subscribe(
              () => {
                this._notification.success('NEW_FILE.FILE_UPLOADED', 'MESSAGE.SUCCESS');
              },
              () => {
                this._notification.errorCustom('NEW_FILE.FILE_UPLOADED', 'MESSAGE.ERROR.SERVER_ERROR_TITLE');
              }
            );
        });
      },
        this._notification.errorServer
      );
  }

  selectRow(obj, idx) {
    obj.selectedRow = idx;
  }

  addClick() {
    console.log("tabgroup", this._tabGroup._tabs.length, this._tabGroup.selectedIndex);
    if (this._tabGroup._tabs.length === 2) {
      this.modal.newFile = true;
    } else {
      if (this._tabGroup.selectedIndex == 0)
        this.modal.newFile = true;
      else if (this.isMineOrShared()) {
        //console.log("create pid", this.canAddPID());
        this.canAddPID() ? this.modal.newPID = true : this._notification.info('MESSAGE.PID_LIMIT_REACHED');
      }

    }
  }

  addSubPID() {
    this.modal.newPID = true;
  }

  userIsAllowed() {
    //console.log("is allowed", !this._user.expired());
    return !this._user.expired() && !(this.pid && this.pid.expired);
  }

  updateContractor(file) {
    this.contractorFileToUpdate = _.cloneDeep(file);
  }

  submitContractorUpdate() {
    this._contractorService.updateContractor(this.contractorFileToUpdate.contractor)
      .subscribe(c => {
        _.forEach(this.files.all.concat(this.files.display).concat(this.pending.all).concat(this.pending.display), file => {
          if (file && file.contractor && this.contractorFileToUpdate && this.contractorFileToUpdate.contractor &&
            file.contractor._id === this.contractorFileToUpdate.contractor._id) {
            file.contractor.name = this.contractorFileToUpdate.contractor.name;
            file.contractor.email = this.contractorFileToUpdate.contractor.email;
            file.contractor.phone = this.contractorFileToUpdate.contractor.phone;
          }
        });
        this.contractorFileToUpdate = null;
      },
        this._notification.errorServer
      );
  }

  duplicateFree(list) {
    return _.uniqBy(list, item => {
      return (<any>item)._id;
    });
  }

  subpidAdded = () => {
    this.subpidTable.doUpdateFilter();
    this._tabGroup.selectedIndex = 1;
  }

  createSubPID = () => {
    this.modalNewPID.addPID(this.subpidAdded);
  }

  reloadFiles() {
    this.files.all = [];
    this.files.display = [];
    this.pending.all = [];
    this.pending.display = [];

    this._fileService.getFromPID(this.pid._id)
      .subscribe(
        (files: any) => {
          //console.log("pid files get", files);
          this.rawfiles = files;
          files.forEach(f => {
            if (f.version) {
              this.files.all.push(f);
              this.files.display.push(f);
            } else {
              this.pending.all.push(f);
              this.pending.display.push(f);
            }
          });
        },
        this._notification.errorServer
      );

  }

  filesAreSelected() {
    return this.selection && this.fileTable.currentSelection().length > 0;
  }

  openDialog(): void {
    console.log("current selection", this.fileTable.currentSelection());

    const dialogRef = this.dialog.open(MassEditDialog, {
      width: '700px',
      height: '600px',
      panelClass: 'mass-edit-container',
      data: { pid: this.pid._id, files: this.rawfiles, selection: this.fileTable.currentSelection() }
    });

    dialogRef.afterClosed().subscribe(result => {
      console.log('The dialog was closed', result);
      if (result) {
        this._fileService.getFromPID(this.pid._id)
          .subscribe(
            (files: any) => {
              this.selection = false;
              this.reloadFiles();
              this.updateFileTable();
            },
            this._notification.errorServer
          );
      }
    });
  }
}



